// extracted by mini-css-extract-plugin
export default {"wrapper":"AW-z","boldPrefix":"BW-z","link":"CW-z","message":"DW-z","image":"EW-z"};